import React, { useState } from "react";
import DataTable from "../../../DataTable/DataTable";

export const columns = (pagination) => [
  {
    title: "SI NO",
    dataIndex: "si_no",
    key: "si_no",
    render: (_, __, index) => {
      const pageIndex = pagination?.current || 1;
      const pageSize = pagination?.pageSize || 10;
      return (pageIndex - 1) * pageSize + index + 1;
    },
  },
  {
    title: "AGE FROM",
    dataIndex: "age_from",
    key: "age_from",
    sorter: (a, b) => (Number(a.age_from) || 0) - (Number(b.age_from) || 0),
    searchable: true,
  },
  {
    title: "AGE TO",
    dataIndex: "age_to",
    key: "age_to",
    sorter: (a, b) => (Number(a.age_to) || 0) - (Number(b.age_to) || 0),
    searchable: true,
  },
  {
    title: "ANNUAL PREMIUM",
    dataIndex: "annual_premium",
    key: "annual_premium",
    sorter: (a, b) => (Number(a.annual_premium) || 0) - (Number(b.annual_premium) || 0),
    searchable: true,
  },
  {
    title: "TOTAL MILE RATE",
    dataIndex: "total_mille_rate",
    key: "total_mille_rate",
    sorter: (a, b) => (Number(a.total_mille_rate) || 0) - (Number(b.total_mille_rate) || 0),
    searchable: true,
  },
  {
    title: "PURE MILE RATE",
    dataIndex: "pure_mille_rate",
    key: "pure_mille_rate",
    sorter: (a, b) => (Number(a.pure_mille_rate) || 0) - (Number(b.pure_mille_rate) || 0),
    searchable: true,
  },
  {
    title: "TERMINAL ILLNESS MILE RATE",
    dataIndex: "terminal_illness_mille_rate",
    key: "terminal_illness_mille_rate",
    searchable: true,
  },
  {
    title: "CRITICAL ILLNESS MILE RATE",
    dataIndex: "critical_illness_mille_rate",
    key: "critical_illness_mille_rate",
    searchable: true,
  },
];

const RackRateList = ({ loading, filteredData, pagination: initialPagination }) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    ...initialPagination,
  });

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const dataWithKeys = React.useMemo(() => {
    return (filteredData || []).map((item, index) => ({
      ...item,
      key: item.id || index,
    }));
  }, [filteredData]);

  return (
    <DataTable
      columns={columns(pagination)}
      dataSource={dataWithKeys}
      pagination={{
        ...pagination,
        total: dataWithKeys?.length || 0,
      }}
      loading={loading}
      onChange={handleTableChange}
    />
  );
};

export default RackRateList;
